import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ErrorPopupForm from './ErrorPopupForm';

import { CardTypes } from '../../utils/enums';

import { sendForm } from '../../containers/VoteRegistration/actions';

import {
    AnimationContainer,
    ContainerAbsolute,
    Body
} from '../../containers/DefaultStyles/AssessmentDetails';

const ErrorPopup = props => (
    <AnimationContainer>
        <ContainerAbsolute>
            <Body>
                <ErrorPopupForm
                    onSubmit={values =>
                        props.sendForm(
                            values,
                            props.apiRequestData,
                            props.answerId,
                            props.formData,
                            props.isMultiActionsCard,
                            props.actionIdentifier
                        )
                    }
                    isFormSubmitting={props.isFormSubmitting}
                    message={props.message}
                    label={props.label}
                    name={props.name}
                />
            </Body>
        </ContainerAbsolute>
    </AnimationContainer>
);

ErrorPopup.propTypes = {
    message: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    sendForm: PropTypes.func.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    answerId: PropTypes.number,
    formData: PropTypes.object,
    actionIdentifier: PropTypes.string.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isFormSubmitting: PropTypes.bool.isRequired
};

export default connect(
    state => {
        return {
            message: state.voteRegistration.errorInfo.message,
            label: Object.values(
                state.voteRegistration.errorInfo.modelState
            )[0].toString(),
            name: Object.keys(state.voteRegistration.errorInfo.modelState)[0].toString(),
            apiRequestData: state.widget.apiRequestData,
            formData: state.voteRegistration.formData,
            answerId:
                state.voteRegistration.completeVoteRegistration.voteRegistrationAnswerId,
            actionIdentifier: state.widget.activeAction.identifier,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isFormSubmitting: state.voteRegistration.isFormSubmitting
        };
    },
    {
        sendForm
    }
)(ErrorPopup);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/ErrorPopup.jsx